import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  NativeDateAdapter,
} from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';

class MonthYearDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: Object): string {
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${year}`;
  }
}

export const CUSTOM_DATE_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-date-month-picker',
  templateUrl: './date-month-picker.component.html',
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
    { provide: DateAdapter, useClass: MonthYearDateAdapter },
  ],
})
export class DateMonthPickerComponent {
  @Input() value: Date | null = null;
  @Output() valueChange = new EventEmitter<Date | null>();

  chosenMonthHandler(normalizedMonth: Date, datepicker: MatDatepicker<any>) {
    this.value = normalizedMonth;
    this.valueChange.emit(this.value);
    datepicker.close();
  }

  reset() {
    this.value = null;
    this.valueChange.emit(null);
  }
}
